const columns = [
  {
    title: '快速入口',
    links: [
      { label: '官网首页主入口', href: '#latest' },
      { label: '备用线路 B', href: '#latest' },
      { label: '移动端专线', href: '#latest' },
      { label: '海外访问线', href: '#latest' },
    ],
  },
  {
    title: '访问帮助',
    links: [
      { label: '打不开这样进', href: '#guide' },
      { label: '线路检测说明', href: '#guide' },
      { label: '常见问题', href: '#faq' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '导航分类', href: '#category' },
      { label: '精选入口', href: '#top' },
      { label: '用户反馈', href: '#community' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-700 text-background-50">
      <div className="w-full max-w-content mx-auto px-4 md:px-10 pt-16 md:pt-20 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-50 text-primary-700 font-heading text-lg font-bold">
                51
              </span>
              <span className="font-heading text-xl font-bold">51网址导航</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-100/85 max-w-md">
              收好一个入口，就不必每次重新搜索。本站持续检测 51网址导航 的官网首页入口与最新可用地址，帮助你稳定、快速地恢复访问。
            </p>
            <a
              href="#top"
              className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 text-primary-700 text-sm font-label whitespace-nowrap hover:bg-background-100 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-up-line"></i>
              返回顶部
            </a>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <h3 className="font-heading text-sm font-bold text-background-50">{col.title}</h3>
                <ul className="mt-4 space-y-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm font-label text-background-100/80 hover:text-background-50 transition-colors"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-background-50/25 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs font-label text-background-100/75">
            © 2026 51网址导航 · 本站为入口指引页面，所有按钮仅作展示
          </p>
          <p className="text-xs font-label text-background-100/75">
            访问异常的线路将自动下线并在本页替换为最新地址
          </p>
        </div>
      </div>
    </footer>
  );
}